import { render, staticRenderFns } from "./ActCategoryList.vue?vue&type=template&id=4a35ac59"
import script from "./ActCategoryList.vue?vue&type=script&lang=js"
export * from "./ActCategoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a35ac59')) {
      api.createRecord('4a35ac59', component.options)
    } else {
      api.reload('4a35ac59', component.options)
    }
    module.hot.accept("./ActCategoryList.vue?vue&type=template&id=4a35ac59", function () {
      api.rerender('4a35ac59', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/flowable/extension/ActCategoryList.vue"
export default component.exports